import { SessionDimensions, SessionsResponse, useSessions } from '@va/dashboard/api-client/sessions.api';
import { Where } from '@va/types/filters';
import { PaginatedResponse, Sorting } from '@va/types/requests';
import { useFetchDataParams } from '@va/util/hooks';
import { useCallback } from 'react';
import { LeafletMapRawPoint } from '../leaflet-map/LeafletMap';

export type VisitorLocation = SessionsResponse<(typeof DIMENSIONS)[number]>;

type Query<T extends string = string> = {
  pagination: { page: number; pageSize: number };
  order?: Sorting<T>[];
  where?: Where;
  config?: useFetchDataParams<LeafletMapRawPoint[]>['config'];
};

const DIMENSIONS = [
  'latitude',
  'longitude',
  'sessionKey',
  'privacyLevel',
  'sessionStartUnix',
] satisfies SessionDimensions[];

export const useVisitorsLocation = (query: Query<(typeof DIMENSIONS)[number]>) => {
  const mapper = useCallback(
    (response: PaginatedResponse<VisitorLocation[]>) =>
      response.payload.map(
        ({ latitude, longitude, sessionKey, privacyLevel }) =>
          ({
            lat: latitude,
            lng: longitude,
            sessionKey,
            privacyLevel,
          }) satisfies LeafletMapRawPoint,
      ),
    [],
  );

  return useSessions(
    {
      trace: 'visitors-location',
      dimensions: DIMENSIONS,
      ...query,
    },
    true,
    mapper,
  );
};
